import _defineProperty from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "menu-tip"
};
import { ShopStatusEnum } from "@/constant/shop";
import { useShopStore } from "@/store/shopStore";
import { useI18n } from "vue-i18n";
export default {
  __name: 'MenuTip',
  setup: function setup(__props) {
    var shopStore = useShopStore();
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var text = _defineProperty(_defineProperty(_defineProperty({}, ShopStatusEnum.CLOSED, t("storeIsNotInBusinessStatus")), ShopStatusEnum.NOT_SUPPORT_DELIVERY, t("storeNotSupportDelivery")), ShopStatusEnum.NOT_SUPPORT_PICKUP, t("storeNotSupportSelfPickup"));
    return function (_ctx, _cache) {
      return _unref(shopStore).getIsShopClosed ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(text[_unref(shopStore).getShopStatus]), 1)) : _createCommentVNode("", true);
    };
  }
};